const JQUERY_CDN_URL = 'https://cdn.jsdelivr.net/npm/jquery@3.4.1/dist/jquery.min.js'

declare global {
  interface Window {
    jQuery?: unknown
    $?: unknown
  }
}

const loadJQuery = () => new Promise<void>((resolve, reject) => {
  if (window.jQuery && window.$) {
    resolve()
    return
  }

  const existingScript = document.querySelector<HTMLScriptElement>(
    `script[src="${JQUERY_CDN_URL}"]`
  )

  if (existingScript) {
    existingScript.addEventListener('load', () => resolve(), { once: true })
    existingScript.addEventListener(
      'error',
      () => reject(new Error('Failed to load jQuery')),
      { once: true }
    )
    return
  }

  const script = document.createElement('script')
  script.src = JQUERY_CDN_URL
  script.async = false
  script.onload = () => resolve()
  script.onerror = () => reject(new Error('Failed to load jQuery'))
  document.head.appendChild(script)
})

export default defineNuxtPlugin({
  enforce: 'pre',
  async setup() {
    await loadJQuery()
  }
})
